module.exports = __webpack_public_path__ + "media/newstyle/images/icon-exit-aila-editor-c329987c531bcc70b2a132e7acb1cc3e.svg";